module.exports = __webpack_public_path__ + "img/pin-1.0ffaaa43.png";